<template>
  <div>
    <div class="horizFlex">
        <label :class="infobigclass">{{contact.name}}</label>
        <button @click="toggle()" class="togglebutton" v-if="showToggleButton">{{toggleText}}</button>
        
    </div>
    <!-- <label class="infobig">{{contact.phoneNumber}}</label> -->
    
     <linkbutton @click="edit()"  v-if="contact.canBeEdited" toplabel="(edit)"/>    
    <div v-if="showDetailDiv">
        <div class="vertFlex">
           
            <div v-html="contact.infoText" class="infosmall"></div>
            <a :class="infosmallclass" :href="phoneforlink(contact)" target="_blank" >{{contact.phoneNumber}}</a>
            <a :class="infosmallclass" :href="emailforlink(contact)" target="_blank" >{{contact.emailAddress}}</a>
            <!-- <div v-html="contact.emailAddress" class="infosmall"></div> -->
            <a :class="infolinkclass" :href="contact.website" target="_blank">{{contact.website}}</a>
             <div v-html="contact.htmlText" :class="infosmallclass"></div>

        </div>
        
    </div>
     <!-- edit -->
      <actionmodal ref="editmodal"> 
        <template v-slot:body>
            <div >
                <label class="studentname">Edit Badge Information</label>
                <div class="entry">    
         
                    <textarea class="entrymulti"   v-model="contact.infoText" rows="2" cols="20"/>
                </div>
                <!-- <formentry label="new Value" v-model="contact.infoText"/> -->
                <smallbutton @click="save()" toplabel='Save' buttonclass="button buttonprimary" />
                <smallbutton @click="$refs.editmodal.closeModal()" toplabel='Cancel' buttonclass="button buttonprimary" />
            </div>
        </template>
      </actionmodal>
  </div>
</template>

<script>
import actionmodal from './controls/actionmodal.vue'
import formentry from'./controls/entry.vue'
import smallbutton from './controls/button.vue'
import linkbutton from './controls/linkbutton.vue'
export default {
    components:{
        actionmodal,
        formentry,
        smallbutton,
        linkbutton
    },
    name:"badgecontact",
    props:{
        contact:{
            type:Object,
            
        },   
    },
    data(){
        return{
            showDetail:false,
        }
    },
    computed:{
        largeFont(){
            
            if(window.LARGE_FONT==undefined){return false}
            else{return window.LARGE_FONT}
        },
        infobigclass(){
            if(this.largeFont){return "infobig_largefont"}
            else{return "infobig"}
        },
        infosmallclass(){
            if(this.largeFont){return "infosmall_largefont"}
            else{return "infosmall"}
        },
        infolinkclass(){
            if(this.largeFont){return "infolink_largefont"}
            else{return "infolink"}
        },
        showDetailDiv(){
            return this.showDetail || this.contactsExpanded
        },
        toggleText(){
            if(this.showDetail){return "-"}
            else{return "+"}
        },
        showToggleButton(){
            if(this.contact.emailAddress==null && this.contact.website==null && this.contact.infoText==null){
                return false
            }else if(this.contactsExpanded){return false}
            else{return true}
        },
        
        contactsExpanded(){
            if(window.CONTACTS_ALWAYS_EXPANDED==undefined){return false}
            else{return window.CONTACTS_ALWAYS_EXPANDED}
        },
    },
    methods:{
        phoneforlink(contact){
            return 'tel:+' + contact.phoneNumber
        },
        emailforlink(contact){
            return 'mailto:' + contact.emailAddress
        },
        toggle(){
            this.showDetail=!this.showDetail
        },
        edit(){
            this.$refs.editmodal.openModal()
        },
        save(){
            this.$emit("save",this.contact.id, this.contact.infoText)
            this.$refs.editmodal.closeModal()
        }
    }
}
</script>

<style>
.togglebutton{
    border:none;
    margin:2px;
}
.entrymulti{
    visibility: visible;
    font-size:inherit;
    margin:0px 5px 0px 5px;
    
    text-align:left;
    resize:none;
    min-height:50px;
    width:100%;
}

</style>